import { types } from 'actions/authentication/types';

const initialState = {
    isRegisterRequest: false,
    isRegisterSuccess: false,
    isRegisterFailure: false,
    isUserEmailOrPhoneNumberExistsRequest: false,
    isUserEmailOrPhoneNumberExistsSuccess: false,
    isUserEmailOrPhoneNumberExistsFailure: false,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case types.REGISTRATION_REQUEST:
            return {
                ...state,
                isRegisterRequest: payload,
            };
        case types.REGISTRATION_SUCCESS:
            return {
                ...state,
                isRegisterSuccess: payload,
            };
        case types.REGISTRATION_FAILURE:
            return {
                ...state,
                isRegisterFailure: payload,
            };
        case types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_REQUEST:
            return {
                ...state,
                isUserEmailOrPhoneNumberExistsRequest: payload,
            };
        case types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_SUCCESS:
            return {
                ...state,
                isUserEmailOrPhoneNumberExistsSuccess: payload,
            };
        case types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_FAILURE:
            return {
                ...state,
                isUserEmailOrPhoneNumberExistsFailure: payload,
            };
        default:
            return state;
    }
};
